import * as React from "react";

function SvgPanopoly(props, ref) {
  return (
    <svg viewBox="0 0 38 53" width="1em" height="1em" {...{ ...props, ref }}>
      <linearGradient
        id="panopoly_svg__a"
        gradientUnits="userSpaceOnUse"
        x1={1.593}
        y1={36.434}
        x2={14.185}
        y2={36.434}
        gradientTransform="matrix(1 0 0 -1 0 54)"
      >
        <stop offset={0} stopColor="#cb1c81" />
        <stop offset={0.64} stopColor="#9a2985" />
        <stop offset={1} stopColor="#712d86" />
      </linearGradient>
      <path
        d="M1.6 16.5l7.8 7.8 4.8-4.8-8.7-8.8c-1.6 1.8-3 3.7-3.9 5.8"
        fill="url(#panopoly_svg__a)"
      />
      <linearGradient
        id="panopoly_svg__b"
        gradientUnits="userSpaceOnUse"
        x1={0.055}
        y1={29.766}
        x2={9.372}
        y2={29.766}
        gradientTransform="matrix(1 0 0 -1 0 54)"
      >
        <stop offset={0} stopColor="#6a2b80" />
        <stop offset={0.33} stopColor="#532d86" />
        <stop offset={0.68} stopColor="#464e9b" />
        <stop offset={1} stopColor="#199bd1" />
      </linearGradient>
      <path
        d="M.1 24.1c0 2.7.6 5.4 1.7 7.8l7.6-7.6-7.8-7.8c-1 2.4-1.6 5-1.5 7.6"
        fill="url(#panopoly_svg__b)"
      />
      <linearGradient
        id="panopoly_svg__c"
        gradientUnits="userSpaceOnUse"
        x1={7.1}
        y1={8.125}
        x2={19.305}
        y2={8.125}
        gradientTransform="matrix(1 0 0 -1 0 54)"
      >
        <stop offset={0} stopColor="#1fae8f" />
        <stop offset={0.05} stopColor="#26af8b" />
        <stop offset={0.44} stopColor="#5cb46f" />
        <stop offset={1} stopColor="#88bf4c" />
      </linearGradient>
      <path
        d="M7.1 38.8l12 14.1h.2l-.5-10.1c-2.7 0-5.2-2.4-7.5-3.4-.6-.2-1.3-.3-2-.2-.8.1-1.5.2-2.2-.4z"
        fill="url(#panopoly_svg__c)"
      />
      <linearGradient
        id="panopoly_svg__d"
        gradientUnits="userSpaceOnUse"
        x1={1.752}
        y1={21.158}
        x2={18.799}
        y2={21.158}
        gradientTransform="matrix(1 0 0 -1 0 54)"
      >
        <stop offset={0} stopColor="#0ab" />
        <stop offset={0.45} stopColor="#00adab" />
        <stop offset={1} stopColor="#30b091" />
      </linearGradient>
      <path
        d="M1.8 31.9c1.9 4.2 5.3 7.6 9.5 9.4l7.5-7.6-9.4-9.5-7.6 7.7z"
        fill="url(#panopoly_svg__d)"
      />
      <linearGradient
        id="panopoly_svg__e"
        gradientUnits="userSpaceOnUse"
        x1={11.258}
        y1={15.603}
        x2={26.459}
        y2={15.603}
        gradientTransform="matrix(1 0 0 -1 0 54)"
      >
        <stop offset={0} stopColor="#37ac6b" />
        <stop offset={0.47} stopColor="#61b251" />
        <stop offset={1} stopColor="#8ec03e" />
      </linearGradient>
      <path
        d="M11.3 41.4c4.8 2.2 10.3 2.2 15.2.1l-7.7-7.7-7.5 7.6z"
        fill="url(#panopoly_svg__e)"
      />
      <linearGradient
        id="panopoly_svg__f"
        gradientUnits="userSpaceOnUse"
        x1={18.779}
        y1={21.143}
        x2={36.094}
        y2={21.143}
        gradientTransform="matrix(1 0 0 -1 0 54)"
      >
        <stop offset={0} stopColor="#84bf6c" />
        <stop offset={0.49} stopColor="#bbcf49" />
        <stop offset={1} stopColor="#eae22a" />
      </linearGradient>
      <path
        d="M18.8 33.8l7.7 7.7c4.2-1.8 7.7-5.1 9.7-9.3l-7.9-8-9.5 9.6z"
        fill="url(#panopoly_svg__f)"
      />
      <linearGradient
        id="panopoly_svg__g"
        gradientUnits="userSpaceOnUse"
        x1={28.185}
        y1={29.86}
        x2={37.91}
        y2={29.86}
        gradientTransform="matrix(1 0 0 -1 0 54)"
      >
        <stop offset={0} stopColor="#bebc31" />
        <stop offset={0.47} stopColor="#dfd61f" />
        <stop offset={1} stopColor="#fce900" />
      </linearGradient>
      <path
        d="M28.2 24.2l7.9 8c1.2-2.5 1.8-5.3 1.8-8.1 0-2.7-.6-5.5-1.8-8l-7.9 8.1z"
        fill="url(#panopoly_svg__g)"
      />
      <linearGradient
        id="panopoly_svg__h"
        gradientUnits="userSpaceOnUse"
        x1={10.98}
        y1={39.321}
        x2={36.143}
        y2={39.321}
        gradientTransform="matrix(1 0 0 -1 0 54)"
      >
        <stop offset={0} stopColor="#de0b80" />
        <stop offset={0.5} stopColor="#e95b4d" />
        <stop offset={1} stopColor="#fdce07" />
      </linearGradient>
      <path
        d="M11 6.9l17.2 17.3 8-8.1C31.7 6.6 20.5 2.5 11 6.9"
        fill="url(#panopoly_svg__h)"
      />
    </svg>
  );
}

export default React.forwardRef(SvgPanopoly);
